import React from 'react'
import { Link } from 'react-router-dom'
import InstaIcon from '../images/insta.svg'
import TelegramIcon from '../images/telegram-circle.svg'
import { getFooterBlocks, getDocumentLinks } from '../helpers/constant'
import OnlinepbxLogoDark from '../images/onlinepbx-logo-dark.svg'

export const Footer: React.FC = () => {
  const blocks = getFooterBlocks()
  const docLinks = getDocumentLinks()

  const icons: any = {
    InstaIcon: <InstaIcon className='onlinepbx__footer__link__icon' />,
    TelegramIcon: <TelegramIcon className='onlinepbx__footer__link__icon' />
  }

  const renderLink = (link: { url?: string; view: string; fontWeight: number; name: string, color?: string, icon?: string }) => {
    return (
        <div key={!!link.url ? link.url : link.view}>
          {(!!link.url && (
              <a
                  className='onlinepbx__footer__link'
                  style={{ fontWeight: link.fontWeight, ...link.color && { color: link.color } }}
                  rel='noreferrer'
                  target='_blank'
                  href={link.url}
              >
                {link?.icon && icons[link.icon]}
                {link.name}
              </a>
          )) || (
              <Link className='onlinepbx__footer__link' to={`/${link.view}`}>
                {link.name}
              </Link>
          )}
        </div>
    )
  }

  return (
    <div className='onlinepbx__footer__wrapper'>
      <div className='onlinepbx__container'>
        <div className='onlinepbx__footer__logo'>
          <div className='onlinepbx__footer__logo__line' />
          <OnlinepbxLogoDark className='onlinepbx__footer__logo__icon' />
          <div className='onlinepbx__footer__logo__line' />
        </div>
        <div className='onlinepbx__footer'>
          <div className='onlinepbx__footer__links'>
            {blocks.map((block) => (
              <div className='onlinepbx__footer__block' key={block.header}>
                <div className='onlinepbx__footer__header'>{block.header}</div>
                {(block.subHeaders || []).map(subHeaderBlock => ([
                  <div className='onlinepbx__footer__subheader' key={'subheader-' + subHeaderBlock.header}>{subHeaderBlock.header}</div>,
                  (subHeaderBlock.links || []).map(renderLink)
                ]))}
                {(block.links || []).map(renderLink)}
              </div>
            ))}
          </div>
          <div className='onlinepbx__footer__hr'></div>
          <div className='onlinepbx__footer__documents'>
            {
              docLinks.map((link) => {
                return (
                    <a className={`onlinepbx__footer__documents__link ${link.customClass}`} href={link.url} target='_blank'>{link.title}</a>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
